// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3wqFg","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1epLZ","obliqueLine":"membershipbadge_obliqueLine__1OeVj"};